import React from 'react';
import { nanoid } from 'nanoid';

import { useGraphQL } from '../hooks';
import { socialLinks } from '../data';

function ContactInfo() {
  const {
    site: { siteMetadata },
  } = useGraphQL();
  return (
    <article className="space-y-12">
      <dl className="space-y-3 prose-lg">
        <div>
          <dt className="inline font-medium">Phone: </dt>
          <dd className="inline">
            <a
              href={`tel:${siteMetadata.phone.split(' ').join('')}`}
              className="hover:underline focus:shadow-none focus:underline"
            >
              {siteMetadata.phone}
            </a>
          </dd>
        </div>
        <div>
          <dt className="inline font-medium">Address: </dt>
          <dd className="inline">
            <a
              href={siteMetadata.address.googleMaps}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline focus:shadow-none focus:underline"
            >
              {siteMetadata.address.line1},
              <br />
              {siteMetadata.address.line2}
            </a>
          </dd>
        </div>
        <div>
          <dt className="inline font-medium">Email: </dt>
          <dd className="inline">
            <a
              href={`mailto:${siteMetadata.email}`}
              className="hover:underline focus:shadow-none focus:underline"
            >
              {siteMetadata.email}
            </a>
          </dd>
        </div>
      </dl>
      <div className="space-y-3">
        <h2 className="text-lg font-medium">Follow us on:</h2>
        <div className="flex items-center space-x-2">
          {socialLinks.map((node) => (
            <a
              key={nanoid()}
              href={node.url}
              className="transition duration-150 ease-in-out hover:text-light-pink focus:text-light-pink focus:shadow-none"
            >
              <span className="sr-only">{node.label}</span>
              <node.icon className="w-8 h-8" />
            </a>
          ))}
        </div>
      </div>
    </article>
  );
}

export { ContactInfo };
